import { LoadingComponent } from './loading.component';
import { Injectable, ApplicationRef, ComponentFactoryResolver, Injector, ComponentRef, ElementRef } from '@angular/core';
import { LoadingConfig, LOADING_DEFAULT_CONFIG, loaddingDefaultConfig } from './loading.config';

@Injectable()
export class LoadingService {

    config: LoadingConfig;
    private loadingCmpRef: ComponentRef<LoadingComponent>;

    constructor(
        private appRef: ApplicationRef,
        private cfr: ComponentFactoryResolver,
        private injecotr: Injector
    ) {
    }

    show(config?: LoadingConfig): LoadingComponent {
        this.removeDomCheck();
        this.config = this.injecotr.get(LOADING_DEFAULT_CONFIG) || {};
        this.config = Object.assign(loaddingDefaultConfig, this.config);

        const loadingFactory = this.cfr.resolveComponentFactory(LoadingComponent);
        this.loadingCmpRef = loadingFactory.create(this.injecotr);

        if (config) {
            this.config = Object.assign({}, this.config, config);
        }

        const languageCode = localStorage.getItem('languageCode');
        if (languageCode === 'en') {
            this.config.message = 'Loading...';
        }

        const container = this.config.container;
        if (container === 'body') {
            document.querySelector(container as string).appendChild(this.loadingCmpRef.location.nativeElement);
        } else {
            if (container instanceof ElementRef) {
                container.nativeElement.appendChild(
                    this.loadingCmpRef.location.nativeElement
                );
            }
        }
        this.loadingCmpRef.instance.isActive = true;
        Object.assign(this.loadingCmpRef.instance, this.config);

        this.loadingCmpRef.instance.closed.subscribe(state => {
            if (!state) {
                this.clearDom(this.loadingCmpRef);
            }
        });

        this.loadingCmpRef.changeDetectorRef.markForCheck();
        this.loadingCmpRef.changeDetectorRef.detectChanges();

        return this.loadingCmpRef.instance;
    }

    close() {
        if (!!this.loadingCmpRef) {
            this.clearDom(this.loadingCmpRef);
        }
    }

    private clearDom(cmpRef: ComponentRef<LoadingComponent>) {
        try {
            const loadingEl = cmpRef.location.nativeElement;

            if (!!loadingEl && loadingEl.parentNode) {
                loadingEl.parentNode.removeChild(loadingEl);
            }

            this.config = this.injecotr.get(LOADING_DEFAULT_CONFIG);
            cmpRef.destroy();
            cmpRef = null;
            setTimeout(() => {
                // 1.5s 后检查是否移除成功
                this.removeDomCheck();
            }, 1500);
        } catch (e) {
            console.log(e);
            this.removeDomCheck();
        }
    }

    private removeDomCheck(): void {
        try {
            const el = document.getElementsByTagName('framework-loading')[0];
            if (!!el && !!el.parentNode) {
                el.parentNode.removeChild(el);
            }
        } catch (ex) {
            console.log(ex);
        }
    }
}

